<template>
  <div class="benefits_holder">
    <p class="benefits_item benefits_item__prem" id="benefits_item__prem" @mouseover="onTrackHover">
      {{ $t('30 дней танкового премиум аккаунта в подарок') }}
    </p>
    <p class="benefits_item benefits_item__gold" id="benefits_item__gold" @mouseover="onTrackHover">
      {{ $t('До 8.5 золота за каждые 100 RUB, потраченных по карте') }}
    </p>
    <p class="benefits_item benefits_item__farm-gold" id="benefits_item__farm-gold" @mouseover="onTrackHover">
      {{ $t('Плюс 5% от стоимости покупок в Премиум-магазине в виде золота') }}
    </p>
    <p class="benefits_item benefits_item__reserves" id="benefits_item__reserves" @mouseover="onTrackHover">
      {{ $t('27 личных резервов при обороте от 30 000 RUB в месяц') }}
    </p>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import BenefitsBase from '../BenefitsBase.vue'

@Component
class BenefitsMtRu extends BenefitsBase {
}

export default BenefitsMtRu
</script>
